
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#43a047","d":"M37 45H11a3 3 0 01-3-3V6a3 3 0 013-3h19l10 10v29a3 3 0 01-3 3z"}}),_c('path',{attrs:{"fill":"#c8e6c9","d":"M40 13H30V3z"}}),_c('path',{attrs:{"fill":"#2e7d32","d":"M30 13l10 10V13z"}}),_c('path',{attrs:{"fill":"#e8f5e9","d":"M31 23H15v14h18V23h-2zm-14 2h4v2h-4v-2zm0 4h4v2h-4v-2zm0 4h4v2h-4v-2zm14 2h-8v-2h8v2zm0-4h-8v-2h8v2zm0-4h-8v-2h8v2z"}})])
          )
        }
      }
    